import type { WrittenReview } from '../types/review';

// Si estas opiniones son reales y tenés autorización de cada profesional,
// cambialo a false para quitar la etiqueta "Testimonios ilustrativos".
export const TESTIMONIALS_ARE_ILLUSTRATIVE = true;

export const writtenReviews: WrittenReview[] = [
  {
    name: 'Mariana R.',
    profession: 'Psicóloga',
    quote:
      'Lo que más me gustó es que no es simplemente teoría. Encontré herramientas concretas, preguntas y recursos que puedo adaptar a mis consultas. Me ahorró muchísimo tiempo de preparación.',
  },
  {
    name: 'Lucía M.',
    profession: 'Sexóloga',
    quote:
      'Antes tenía materiales guardados en distintos lugares y muchas veces terminaba preparando todo desde cero. Tener las sesiones y recursos organizados en un solo lugar me resultó súper práctico.',
  },
  {
    name: 'Camila G.',
    profession: 'Psicóloga y sexóloga',
    quote:
      'Me encantó la variedad de recursos. Hay situaciones que aparecen en consulta y no siempre sabés qué herramienta utilizar. Tener diferentes opciones para consultar y adaptar me da mucha más seguridad al momento de trabajar.',
  },
  {
    name: 'Sofía P.',
    profession: 'Psicóloga',
    quote:
      'Lo compré principalmente para dejar de perder horas buscando y armando material. La verdad es que cumplió exactamente con eso. Está muy bien organizado y puedo ir directamente al recurso que necesito.',
  },
  {
    name: 'Valentina A.',
    profession: 'Profesional de la salud sexual',
    quote:
      'Fue una de esas compras que realmente terminé usando. Las sesiones listas y los materiales de evaluación son lo que más aproveché. Me parece especialmente útil para tener recursos a mano cuando necesitás preparar una consulta rápidamente.',
  },
];
